import {
  DrawerFormBody,
  DrawerFormLabel,
  DrawerFormValue,
  DrawerlabelContainer,
} from "./DrawerStyled";
import Dropdown from "../Dropdown/Dropdown";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import { formatFileSize } from "../../utils/fileUtils";

const FilePropertiesTab = ({
  updateMeta,
  handleCaseTypeSelect,
  categoryList,
  disabled, 
}) => {
  const categoryValue =
    updateMeta?.doc_category || updateMeta?.category || "Select Category";

  return (
    <DrawerFormBody>
      <DrawerlabelContainer>
        <DrawerFormLabel>Filename</DrawerFormLabel>
        <DrawerFormValue>{updateMeta?.name || "-"}</DrawerFormValue>
      </DrawerlabelContainer>
      <DrawerlabelContainer>
        <DrawerFormLabel>File Type</DrawerFormLabel>
        <DrawerFormValue>{updateMeta?.file_type || "-"}</DrawerFormValue>
      </DrawerlabelContainer>
      <DrawerlabelContainer>
        <DrawerFormLabel>File Size</DrawerFormLabel>
        <DrawerFormValue>
          {updateMeta?.size != null ? formatFileSize(updateMeta.size) : "-"}
        </DrawerFormValue>
      </DrawerlabelContainer>
      <DrawerlabelContainer>
        <DrawerFormLabel>
          {updateMeta?.newly_created ? "Created on" : "Uploaded on"}
        </DrawerFormLabel>
        <DrawerFormValue>
          {updateMeta?.uploaded_at &&
          dayjs(updateMeta.uploaded_at).isValid()
            ? dayjs(updateMeta.uploaded_at).format("DD MMM YYYY")
            : "-"}
        </DrawerFormValue>
      </DrawerlabelContainer>
      <DrawerlabelContainer>
        <DrawerFormLabel>Last Modified on</DrawerFormLabel>
        <DrawerFormValue>
          {updateMeta?.last_modified &&
          dayjs(updateMeta.last_modified).isValid()
            ? dayjs(updateMeta.last_modified).format("DD MMM YYYY h:mm A")
            : "-"}
        </DrawerFormValue>
      </DrawerlabelContainer>
      <DrawerlabelContainer>
        <DrawerFormLabel>Last Modified by</DrawerFormLabel>
        <DrawerFormValue>
          {updateMeta?.modified_by_user || updateMeta?.modified_by_name || "-"}
        </DrawerFormValue>
      </DrawerlabelContainer>
      <DrawerlabelContainer>
        <DrawerFormLabel>Category</DrawerFormLabel>
        <DrawerFormValue>
          <Dropdown
            allowborder={true}
            value={categoryValue}
            handleChange={handleCaseTypeSelect}
            options={categoryList || []}
            disabled={disabled}
          />
        </DrawerFormValue>
      </DrawerlabelContainer>
    </DrawerFormBody>
  );
};

FilePropertiesTab.propTypes = {
  updateMeta: PropTypes.shape({
    modified_by_user: PropTypes.string,
    modified_by_name: PropTypes.string,
    uploaded_at: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Date),
    ]),
    last_modified: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Date),
    ]),
    newly_created: PropTypes.bool,
    name: PropTypes.string,
    file_type: PropTypes.string,
    size: PropTypes.number,
    category: PropTypes.string,
    doc_category: PropTypes.string,
  }).isRequired,
  handleCaseTypeSelect: PropTypes.func.isRequired,
  categoryList: PropTypes.array.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default FilePropertiesTab;
